var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waveform dac"},_vm._l((_vm.bar),function(item,index){return _c('div',{key:index,staticClass:"bar"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }